export default "__VITE_ASSET__CFTR413___"